import { useState, useEffect } from "react";
import { db } from "../firebase";
import { collection, addDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";

function CreateBR() {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    title: "SOLO BATTLE ROYALE😈🔥(ORION,A124 AND RYDEN BAN)",
    map: "Bermuda",
    mode: "Battle Royale",
    team: "Solo",
    entryFee: 25,
    perKill: 0,
    prizePool: 0,
    totalSpots: 20,
    time: "",
  });

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const t = new Date(Date.now() + 60 * 60 * 1000)
      .toISOString()
      .slice(0, 16);

    setForm((prev) => ({ ...prev, time: t }));
  }, []);

  useEffect(() => {
    const entry = Number(form.entryFee);

    const perKill = Math.round(entry - entry * 0.2);
    const prize = perKill * Number(form.totalSpots);

    setForm((prev) => ({
      ...prev,
      perKill,
      prizePool: prize,
    }));
  }, [form.entryFee, form.totalSpots]);

  const handle = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const createTournament = async () => {
    if (!form.title || !form.time) {
      alert("Fill all fields");
      return;
    }

    setLoading(true);

    try {
      let playerPerTeam = 1;
      if (form.team === "Duo") playerPerTeam = 2;
      if (form.team === "Squad") playerPerTeam = 4;

      const spotsLeft = Array.from(
        { length: Number(form.totalSpots) },
        () => playerPerTeam
      );

      await addDoc(collection(db, "br_tournaments"), {
        ...form,
        entryFee: Number(form.entryFee),
        perKill: Number(form.perKill),
        prizePool: Number(form.prizePool),
        totalSpots: Number(form.totalSpots),
        time: new Date(form.time),
        spotsLeft,
        roomID: "Coming Soon",
        roomPass: "Coming Soon",
        createdAt: new Date(),
        status: "upcoming",
        winnerDeclared: false,
      });

      alert("BR Created ✅");
      navigate(-1);
    } catch (e) {
      alert(e.message);
    }

    setLoading(false);
  };

  return (
    <div style={container}>
      <div style={card}>
        <h2 style={title}>🔥 Create BR Tournament</h2>

        <Input
          label="Tournament Title"
          name="title"
          value={form.title}
          onChange={handle}
          placeholder="Enter tournament title"
        />

        <Input
          label="Map"
          name="map"
          value={form.map}
          onChange={handle}
          placeholder="Bermuda / Purgatory"
        />

        <Input
          label="Mode"
          name="mode"
          value={form.mode}
          onChange={handle}
          placeholder="Battle Royale"
        />

        {/* TEAM */}
        <div>
          <label style={label}>Team Type</label>
          <select
            name="team"
            value={form.team}
            onChange={handle}
            style={input}
          >
            <option value="Solo">Solo</option>
            <option value="Duo">Duo</option>
            <option value="Squad">Squad</option>
          </select>
        </div>

        <Input
          label="Entry Fee (₹)"
          type="number"
          name="entryFee"
          value={form.entryFee}
          onChange={handle}
          placeholder="Enter entry fee"
        />

        <Input
          label="Total Spots"
          type="number"
          name="totalSpots"
          value={form.totalSpots}
          onChange={handle}
          placeholder="Enter total players"
        />

        <Input label="Per Kill (Auto)" value={form.perKill} readOnly />
        <Input label="Prize Pool (Auto)" value={form.prizePool} readOnly />

        <Input
          label="Match Time"
          type="datetime-local"
          name="time"
          value={form.time}
          onChange={handle}
        />

        <button onClick={createTournament} style={btn}>
          {loading ? "Creating..." : "🚀 Create Tournament"}
        </button>
      </div>
    </div>
  );
}

/* 🔥 REUSABLE INPUT */
function Input({ label, ...props }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
      <label style={labelStyle}>{label}</label>
      <input {...props} style={input} />
    </div>
  );
}

/* 🔥 STYLES */

const container = {
  minHeight: "100vh",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  background: "linear-gradient(135deg, #0F1221, #0A0D1A)",
};

const card = {
  background: "#1E2235",
  padding: 25,
  borderRadius: 14,
  display: "flex",
  flexDirection: "column",
  gap: 14,
  width: 360,
  color: "#fff",
  boxShadow: "0 0 20px rgba(0,0,0,0.4)",
};

const title = {
  textAlign: "center",
  marginBottom: 10,
};

const labelStyle = {
  fontSize: 12,
  color: "#9CA3AF",
};

const label = {
  fontSize: 12,
  color: "#9CA3AF",
  marginBottom: 4,
};

const input = {
  padding: "10px 12px",
  borderRadius: 8,
  border: "1px solid #2D334A",
  background: "#111827",
  color: "#fff",
  outline: "none",
};

const btn = {
  marginTop: 10,
  padding: 12,
  border: "none",
  borderRadius: 10,
  background: "#2563EB",
  color: "#fff",
  cursor: "pointer",
  fontWeight: "bold",
};

export default CreateBR;